import { Controller } from "@hotwired/stimulus"

// Nearby heritage sites (docs/icomos.md, "Béns propers"). The browser asks
// for the position only when the evaluator presses the button; the position
// goes to the server for this one answer and is never stored.
export default class extends Controller {
  static targets = ["frame", "status"]
  static values = { url: String, messages: Object }

  locate(event) {
    if (!("geolocation" in navigator)) return this.say("unsupported")

    event?.currentTarget?.setAttribute("disabled", "")
    this.say("locating")
    navigator.geolocation.getCurrentPosition(
      (position) => this.show(position.coords),
      (error) => {
        event?.currentTarget?.removeAttribute("disabled")
        this.say(error.code === error.PERMISSION_DENIED ? "denied" : "unavailable")
      },
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 60000 }
    )
  }

  show({ latitude, longitude }) {
    const url = new URL(this.urlValue, window.location.origin)
    url.search = new URLSearchParams({ latitude, longitude })
    this.frameTarget.src = url.toString()
    this.frameTarget.loaded.then(() => this.say(null))
  }

  say(key) {
    this.statusTarget.hidden = !key
    this.statusTarget.textContent = key ? this.messagesValue[key] : ""
  }
}
